module.exports = __webpack_public_path__ + "media/gocd_logo-dd25c21862f1743ca06331a53db248fa.svg";